import { jwtDecode } from 'jwt-decode';

export const isTokenExpired = (jwtToken: string): boolean => {
  if (!jwtToken) {
    return false;
  }

  const sec = (jwtDecode(jwtToken) as any).exp as number;
  var isExpired = Date.now() >= sec * 1000;
  return isExpired;
};

// False for a missing or corrupt value (for example a truncated cookie), which can never be refreshed or sent.
export const isTokenDecodable = (jwtToken: string | null | undefined): jwtToken is string => {
  if (!jwtToken) {
    return false;
  }

  try {
    jwtDecode(jwtToken);
    return true;
  } catch {
    return false;
  }
};

// True when the token decodes, carries an expiry and has not expired yet. A token without exp is not trusted.
export const isTokenUsable = (jwtToken: string | null | undefined): boolean => {
  if (!isTokenDecodable(jwtToken)) {
    return false;
  }

  const expiresAt = (jwtDecode(jwtToken) as { exp?: unknown }).exp;

  return typeof expiresAt === 'number' && Date.now() < expiresAt * 1000;
};
